<div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasBottomLabel">{{title}}</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <div class="row">
      <div class="col-md-6" style="padding-left: 15%;">
        <div class="card border-light">
          <div class="card-body">
            <h5 class="card-title">Download</h5>
            <p class="card-text">This document has {{subscribers}} signature(s), and is available for download.</p>
            <div class="row">
              <div class="col-md-4">
                <div class="card border-success mb-3" style="max-width: 18rem; cursor: pointer;">
                  <div class="card-body text-success">
                    <div class="row">
                      <div class="col-md-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor"
                          class="bi bi-download" viewBox="0 0 16 16">
                          <path
                            d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path
                            d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </div>
                      <div class="col-md-10">
                        <p class="card-text text-center">Original Document .PDF</p>
                      </div>
                    </div>
                    <a (click)="downloadFile(doc, 'original')" class="stretched-link"></a>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card border-success mb-3" style="max-width: 18rem; cursor: pointer;">
                  <div class="card-body text-success">
                    <div class="row">
                      <div class="col-md-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor"
                          class="bi bi-download" viewBox="0 0 16 16">
                          <path
                            d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path
                            d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </div>
                      <div class="col-md-10">
                        <p class="card-text text-center">Signed Document .PDF</p>
                      </div>
                    </div>
                    <a (click)="downloadFile(docSigned, 'signed')" class="stretched-link"></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" style="padding-right: 15%;">
        <div class="card {{cardBorder}}">
          <div class="card-body">
            <h5 class="card-title {{tileColor}}">
              <div class="row justify-content-between">
                <div class="col-4">
                  Verify Signature
                </div>
                <div class="col-4 text-end" *ngIf="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" *ngIf="valid" width="16" height="16" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                      <path d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" *ngIf="!valid" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                    <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"/>
                  </svg>
                </div>
              </div>
            </h5>
            <p class="card-text">Verify the document's digital signature, enter the SHA-256 or SHA-512 encrypted hash.
            </p>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                value="SHA-256" [(ngModel)]="typeSHA">
              <label class="form-check-label" for="inlineRadio1">SHA-256</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                value="SHA-512" [(ngModel)]="typeSHA">
              <label class="form-check-label" for="inlineRadio2">SHA-512</label>
            </div>
            <div style="padding-top: 5px; padding-bottom: 10px;">
              <textarea [(ngModel)]="SHA" class="form-control" id="exampleFormControlTextarea1"
                (change)="onItemChange()"></textarea>
            </div>
            <button type="button" pButton (click)="verifyDigitalSignature()" class="btn btn-primary"
              label="Verify">Verify</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>